import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { TeamService } from '@maia/shared';
import { TeamController } from './team.controller';

export class TeamFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'teamUrl');

  createBrokerController(): TeamController {
    return new TeamController(this.createTeamService());
  }

  private createTeamService(): TeamService {
    return new TeamService(this.httpService, this.configService);
  }
}

const factory = new TeamFactory();
export const service = factory.createBrokerController();
